'use strict';

angular.module('clientDashboardApp').directive('inlineSpinner',function() {
  return {
    restrict: 'E',
    scope: {
      updating: '=',
    },
    template: `<span ng-show="updating"><span class="fas fa-spinner fa-spin fa-status"></span></span>`
  }
});
